import { Text } from '@thanx/uikit/text'
import { ReactComponent as ThanxAiSparkles } from 'assets/images/thanx-ai-sparkles.svg'
import SegmentStateBadge from 'components/SegmentStateBadge'
import { buildTranslate } from 'locales'
import { Fields as TargetSegment } from 'models/TargetSegment'

import 'components/SegmentDetails/segmentDetails.scss'

const t = buildTranslate('segments.segment_page')

const getCreationText = (segment: TargetSegment) => {
  const hasCreatorInfo =
    segment?.merchant_user?.first_name && segment?.merchant_user?.last_name
  const creatorName =
    hasCreatorInfo && segment.merchant_user
      ? `${segment.merchant_user.first_name} ${segment.merchant_user.last_name}`
      : 'Thanx'
  const isAIGenerated = segment?.ai_generated ?? false
  const hasDate = !!segment?.created_at

  const getTranslationKey = () => {
    if (hasDate) {
      if (isAIGenerated) return 'created_by_with_ai'
      return 'created_by'
    } else {
      if (isAIGenerated) return 'created_by_with_ai_no_date'
      return 'created_by_no_date'
    }
  }

  const translationKey = getTranslationKey()
  const params: { creator_name: string; date?: string } = {
    creator_name: creatorName,
  }

  if (hasDate) {
    const createdDate = new Date(segment.created_at!).toLocaleDateString(
      'en-US',
      {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      }
    )
    params.date = createdDate
  }

  return t(translationKey, params)
}

interface SegmentDescriptionProps {
  segment: TargetSegment
}

const SegmentDescription = ({ segment }: SegmentDescriptionProps) => (
  <div>
    <div className="d-flex align-items-center mt-xs">
      <ThanxAiSparkles className="mr-2 segment-thanx-logo" />
      <Text.BodyText3 color="grey60" className="mb-0">
        {getCreationText(segment)}
      </Text.BodyText3>
      {segment?.state === 'requires_approval' && (
        <SegmentStateBadge className="ml-3" />
      )}
    </div>
  </div>
)

export default SegmentDescription
